import { render, staticRenderFns } from "./StartupTrackersWidget.vue?vue&type=template&id=91d650b0&scoped=true&"
import script from "./StartupTrackersWidget.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupTrackersWidget.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d650b0",
  null
  
)

export default component.exports